<template>
  <div class="login-container">
    <div class="login-header">
      <a href="http://www.spr-atm.com">
        <img src="@images/logo2.png" />
      </a>
      <div class="login">登录</div>
    </div>
    <div class="login-main">
      <div class="login-left">
        <div class="title">
          <div class="cn">
            客户查询
          </div>
          <div class="line"></div>
          <div class="en">
            Customer Inquirie
          </div>
        </div>
        <div class="slogan">
          <div class="cn">
            万款现货 · 精准匹配 · 高效采购
          </div>
          <div class="en">
            Thousands of In-Stock Items · Precise Matching · Efficient
            procurement
          </div>
        </div>
        <ul>
          <li>
            <div class="cn">
              <div class="dot"></div>
              一站式ATM配件采购服务
            </div>
            <div class="en">One-Stop ATM Parts Procurement Service</div>
          </li>
          <li>
            <div class="cn">
              <div class="dot"></div>
              全流程订单与物流跟踪
            </div>
            <div class="en">End-to-End Order and LogisticsTracking</div>
          </li>
          <li>
            <div class="cn">
              <div class="dot"></div>
              采购需求快速响应机制
            </div>
            <div class="en">
              Rapid Response Mechanism for Procurement Requests
            </div>
          </li>
          <li>
            <div class="cn">
              <div class="dot"></div>
              优质行业资源共建共享
            </div>
            <div class="en">
              Collaborative Development and Sharing of High-Quality Industry
              Resources
            </div>
          </li>
        </ul>
        <div class="bottom">
          <div class="cn">一站式ATM配件供应 | 从询价到交付全程无忧</div>
          <div class="en">
            One-Stop ATM Parts Supply I Hassle-Free Service from Quote to
            Delivery
          </div>
        </div>
      </div>
      <div class="login-right">
        <div class="title">
          <img src="@images/cooperation_lib_logo.png" alt="客户查询系统" />
          <div class="cn">
            客户查询系统
          </div>
          <div class="en">
            Customer Inquiry System
          </div>
        </div>
        <el-form
          :model="loginForm"
          :rules="loginFormRules"
          autoComplete="on"
          ref="loginFormRef"
        >
          <el-form-item prop="username">
            <el-input
              placeholder="请输入用户名 (User name)"
              v-model="loginForm.username"
              autoComplete="on"
              clearable
              size="mini"
              prefix-icon="iconfont icon-user"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码 (Password)"
              type="password"
              autoComplete="on"
              clearable
              size="mini"
              v-model="loginForm.password"
              prefix-icon="iconfont icon-password"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          :loading="isLoading"
          class="login-btn"
          @click.prevent="login"
        >
          VIP登录(VIP Login)
        </el-button>
        <a class="forget-password" href="/Entrust/UserInfo">
          <span class="cn">没有账号？可先申请成为VIP</span>
          <span class="en">Don't have an account? Sign up for VIP</span>
        </a>
        <router-link to="/login" class="supplier-login-btn">
          <span>供应商登录(Supplier Login)</span>
        </router-link>
        <div class="bottom">
          <div class="forget-password" @click="handleForgetPassword">
            <span class="cn">忘记密码</span>
            <span class="en">Forgot password</span>
          </div>
          <div class="line"></div>
          <a class="forget-password" href="/Entrust/UserInfo">
            <span class="cn">申请成为VIP</span>
            <span class="en">Apply to Become a VIP</span>
          </a>
        </div>
      </div>
    </div>
    <div class="login-footer">
      Copyright &copy; 2019-2026 深圳市森普瑞科技 版权所有
      <!-- <cnzz /> -->
    </div>
    <el-dialog
      class="tips-dialog"
      title="温馨提示！"
      :visible.sync="isShowTips"
      :before-close="handleClose"
      top="40vh"
      width="445px"
    >
      <p>
        忘记密码请您联系：
      </p>
      <p>客服电话：0755-82405890-8931</p>
      <p>客服邮箱：atm8123@spr-atm.com</p>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import qs from 'qs'

// import CNZZ from '@/components/public/CNZZ.vue'

export default {
  components: {
    // cnzz: CNZZ
  },
  data() {
    return {
      isLoading: false,
      isShowTips: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      redirectUrl: this.$route.query.redirectUrl || '/home'
    }
  },
  created() {},
  mounted() {},
  methods: {
    login() {
      this.$refs.loginFormRef.validate(valid => {
        if (valid) {
          this.isLoading = true
          const params = {
            name: this.loginForm.username,
            pwd: this.loginForm.password
          }
          var protocol = window.location.protocol.split(':')[0]
          var url = `/Home/singin2`
          axios
            .post(url, qs.stringify(params), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then(res => {
              this.isLoading = false
              if (res.data.success) {
                // 触发google统计事件
                try {
                  // 给谷歌发送事件
                  if (typeof gtag !== 'undefined') {
                    gtag('event', 'vip登录', {
                      name: params.name
                    })
                  } else {
                    console.warn('gtag 未加载完成，事件未发送:', eventName)
                  }
                } catch (e) {
                  console.log('err', e)
                }
                alert('登录成功！(Login Successfully!)')
                // this.$message.success('登录成功！(Login Successfully!)')
                window.location.replace(res.data.ReturnUrl)
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              console.log(err)
              this.isLoading = false
            })
        }
      })
    },
    handleForgetPassword() {
      this.isShowTips = true
    }
  }
}
</script>
<style lang="less" scoped>
.login-container {
  padding-top: 1%;
  height: 100%;
  min-height: 900px;
  position: relative;
  font-family: 'HarmonyOS Sans SC', 'Source Han Sans CN';
  background: url('../assets/images/login_bg1.jpg') center / cover no-repeat
    fixed;
  // display: flex;
  justify-content: center;
  align-items: center;
}
.login-main {
  position: relative;
  width: 1072px;
  height: 700px;
  margin: auto;
}
.login-header {
  // position: absolute;
  // left: 0;
  // top: -80px;
  height: 50px;
  width: 1072px;
  margin: 0 auto 22px auto;
  display: flex;
  align-items: center;
  a {
    height: 100%;
    margin-right: 20px;
    cursor: pointer;
    img {
      height: 100%;
    }
  }
  .login {
    height: 100%;
    line-height: 50px;
    padding-left: 20px;
    border-left: 1px solid #e3ecf8;
    font-size: 25px;
    color: #f6f9fd;
  }
}
.login-left {
  background: url('../assets/images/user_login_bg.jpg') no-repeat;
  background-size: 100% 100%;
  width: 556px;
  height: 700px;
  box-shadow: 0px 16px 25px rgba(76, 99, 211, 0.54) !important;
  border: none;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}
.login-right {
  background-color: #ffffff;
  width: 525px;
  height: 651px;
  box-shadow: 0px 16px 20px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  position: absolute;
  right: 0;
  top: 20px;
}
.tips-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  p {
    font-family: 'Source Han Sans CN';
    text-indent: 2em;
    font-size: 14px;
    line-height: 24px;
  }
}
.login-footer {
  margin: 35px auto;
  width: 1072px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
}

.login-main + .login-footer {
  margin-top: 35px;
}
</style>

<style lang="less" scoped>
// 左侧栏内容调整
.login-left {
  font-family: 'HarmonyOS Sans SC';
  font-weight: 300;
  color: #ffffff;
  padding: 47px 36px;

  .cn + .en {
    margin-top: 4px;
  }

  .title {
    .cn {
      font-weight: 300;
      font-size: 34px;
      line-height: 40px;
    }
    .en {
      font-weight: 300;
      font-size: 14px;
      line-height: 16px;
    }
    .line {
      width: 68px;
      border-top: 1px solid;
      margin: 5px;
    }
  }

  .slogan {
    margin-top: 25px;

    .cn {
      font-size: 20px;
      line-height: 24px;
    }

    .en {
      font-size: 14px;
      line-height: 16px;
    }
  }

  ul {
    margin: 93px 0;

    .cn {
      font-size: 18px;
      line-height: 21px;
      display: flex;
      align-items: center; /* 垂直居中 */

      .dot {
        width: 6px;
        height: 6px;
        flex: none;
        border-radius: 50%;
        background: #fff;
        margin-right: 10px;
      }
    }

    .en {
      font-size: 12px;
      line-height: 14px;
    }

    li + li {
      margin-top: 28px;
    }
  }

  .bottom {
    .cn {
      font-size: 20px;
      line-height: 24px;
    }

    .en {
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>

<style lang="less" scoped>
// 右侧栏内容调整
.login-right {
  font-family: 'HarmonyOS Sans SC';
  font-weight: 300;
  color: #ffffff;
  padding: 58px 83px 74px 88px;

  .title {
    width: 206px;
    margin: 0 auto 40px auto;
    justify-items: center;
    text-align: center;
    color: #4a62d0;

    .cn {
      font-weight: 300;
      font-size: 24px;
      line-height: 28px;
    }
    .en {
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
    }

    img + .cn {
      margin-top: 12px;
    }
  }

  .el-input {
    /deep/ .el-input__inner {
      height: 38px;
      border: none;
      border-bottom: 1px solid #99b9f2;
      border-radius: 0;
      outline: none;
      input {
        border: none;
        outline: none;
      }
    }
    /deep/ input::-webkit-input-placeholder {
      color: #99b9f2 !important;
    }
    /deep/ input::-moz-placeholder {
      color: #99b9f2 !important;
    }
    &::after {
      position: absolute;
      content: '*';
      top: -2px;
      left: -2px;
      color: #d36b75;
    }
  }

  .login-btn {
    margin-top: 46px;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(91deg, #4d64d3 0%, #7ca7ed 100%);
    border-radius: 8px;
    box-shadow: 0px 5px 10px rgba(76, 99, 211, 0.3);
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 34px;
    color: #ffffff;
  }

  .supplier-login-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #99b9f2;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 34px;
    color: #99b9f2;

    span {
      flex: none;
    }
  }

  > .forget-password {
    display: block;
    margin: 6px auto 18px auto;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #99b9f2;

    span {
      display: block;
    }
  }

  .bottom {
    display: flex;
    height: 33px;
    align-items: center; /* 垂直居中 */
    justify-content: center;
    margin-top: 32px;
    color: #99b9f2;
    font-size: 14px;

    span {
      display: block;
      line-height: 16px;
    }

    .line {
      width: 1px;
      height: 14px;
      background: #99b9f2;
      margin: 0 19px;
    }

    .forget-password {
      height: 33px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
    }

    a {
      display: block;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #99b9f2;
    }

    .cn + .en {
      margin: 1px 0;
    }
  }
}
</style>
